import { createFileRoute } from "@tanstack/react-router";
import {
  useTranslation,
  TRANSLATION_NAMESPACE,
} from "@bfc-software/bfc-web-ui/i18n";
import { WarehouseFrontDoor } from "@bfc-software/bfc-web-ui/ui/shared/warehouse-front-door";

/**
 * Outbound's front door, where it picks up a warehouse.
 *
 * Tasks, items and locations are all warehouse-scoped, so there is no
 * screen inside Outbound that can be drawn without one. Tasks is where a manager
 * starts their day, so it is where this lands.
 */
export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/outbound/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { lang } = Route.useParams();
  const { t } = useTranslation({
    lang,
    namespace: TRANSLATION_NAMESPACE.portal,
  });

  return (
    <WarehouseFrontDoor
      product={t("products.outbound.title")}
      to="/$lang/orgs/$org/outbound/whs/$location/tasks"
    />
  );
}
